import {
	BooleanField,
	BooleanInput,
	CreateButton,
	Datagrid,
	EmailField,
	FilterButton,
	List,
	SearchInput,
	TextField,
	TopToolbar,
} from "react-admin";
import { UserListExportButton } from "../../components/UserListExportButton";

import { useGlobalPermission } from "../../permissions";
import { useScreenWidth } from "../../media";

const filters = [
	<SearchInput source="q" alwaysOn />,
	<BooleanInput source="webex_account_active" label="Active in Webex" />,
	<BooleanInput source="admin" defaultValue={true} />,
];

const UserListActions = () => {
	const usersCreatePermission = useGlobalPermission("users.create");
	const usersExportPermission = useGlobalPermission("users.export");

	return (
		<TopToolbar>
			<FilterButton />
			{usersCreatePermission && <CreateButton />}
			{usersExportPermission && <UserListExportButton />}
		</TopToolbar>
	);
};

export const UserList = () => {
	const createUsersPermission = useGlobalPermission("users.create");
	const smallScreen = useScreenWidth("mobile");
	const mediumScreen = useScreenWidth("sm");
	const largeScreen = useScreenWidth("md");
	const xlScreen = useScreenWidth("lg");

	return (
		<List
			hasCreate={createUsersPermission}
			filters={filters}
			actions={<UserListActions />}
		>
			<Datagrid bulkActionButtons={false} rowClick="show">
				{smallScreen && <TextField source="kid" label="K-ID" />}
				<TextField source="first_name" />
				<TextField source="last_name" />
				{largeScreen && <EmailField source="email" />}
				{mediumScreen && <TextField source="department" />}
				{mediumScreen && (
					<BooleanField source="webex_account_active" label="Active in Webex" />
				)}
				{xlScreen && <BooleanField source="admin" />}
			</Datagrid>
		</List>
	);
};
